export default __webpack_public_path__ + "static/media/coresanscr25-webfont.a28fd5b4.woff2";